module.exports = __webpack_public_path__ + "assets/img/9c1b746786049ff660572ec6967bf206.png";